import React, { Component, useEffect, useState } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import { tender_cat_data, tender_cate_data, tender_org_data, tender_orgn_data, user_tenders_list } from "../user.api";
import "./tenders.css";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { Toast } from "bootstrap";
import BreadCrumpBack from "../../../components/navigator/back";

class tenders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      orgdata: [],
      catdata: [],
      url: "",
      selectedOrgId: "",
      selectedCatId: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  }
  componentDidMount = () => {
    this.fetchTender();
    this.fetchOrganisation();
    this.fetchCategory();
  };

  fetchTender = (orgId = "", catId = "") => {
    user_tenders_list().then((res) => {
      const currentDate = moment();

      const filteredData = res?.data.filter((item) => {
        const isPublic = item.type === "public";
        const isPublished = item.tender_publish_status === 1;
        const isFuture = moment(item?.due_date, "YYYY-MM-DD").isAfter(currentDate);
        const matchesOrg = orgId ? item.organisation?.id == orgId : true;
        const matchesCat = catId ? item.category?.id == catId : true;

        return isPublic && isPublished && isFuture && matchesOrg && matchesCat;
      });

      this.setState({
        data: filteredData,
        url: res.current_url,
        currentPage: 1,
      });
    });
  };

  fetchOrganisation = () => {
    tender_orgn_data().then((res) => {
      const names = res.map((item) => item.name);
      this.setState({
        orgdata: res,
      });
    }).catch((err) => {
      console.error('Error fetching data:', err);
    });
  }
  fetchCategory = () => {
    tender_cate_data().then((res) => {
      const names = res.map((item) => item.name);
      this.setState({
        catdata: res,
      });
    }).catch((err) => {
      console.error('Error fetching data:', err);
    });
  }

  handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  handleDownloadProof = (file) => {
    const servInstance = process.env.REACT_APP_BASE_URL;
    let result = servInstance.substring(0, servInstance?.length - 4);
    let path = `${result}${file}`;
    window.open(path, "_blank");
  };
  formatAmount(amount) {
    return new Intl.NumberFormat('en-IN').format(amount);
  };
  handleOrganisationChange = (e) => {
    const selectedOrgId = e.target.value;
    this.setState({ selectedOrgId, currentPage: 1 }, () => {
      this.fetchTender(selectedOrgId, this.state.selectedCatId);
    });
  };
  handleCategoryChange = (e) => {
    const selectedCatId = e.target.value;
    this.setState({ selectedCatId, currentPage: 1 }, () => {
      this.fetchTender(this.state.selectedOrgId, selectedCatId);
    });
  };
  render() {
    const { data, url, currentPage, itemsPerPage } = this.state;
    const { state } = this.props;
    const { orgdata, selectedOrgId } = this.state;
    const { catdata, selectedCatId } = this.state;
    const currentDate = moment()

    // Pagination calculations
    const totalItems = data.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    return (
      <div className="tender bg-tender">
        <div>
          <div className="dash-banner ">
            <div className="tix">{this.props.state.language === "ma" ? "ടെൻഡറുകൾ" : "Tenders"}</div>
          </div>
        </div>
        <BreadCrumpBack />
        <div className="container p-50">

          <div className="bg-white">
            <div className="row tender-box">
              {currentItems?.length != 0 ? (
                <>
                  {currentItems?.map((item, i) => (
                    <React.Fragment key={i}>

                      {item.tender_publish_status === 1 &&
                        item?.type === "public" &&
                        moment(item?.due_date, "YYYY-MM-DD").isAfter(
                          currentDate
                        ) && (
                          <div className="bg-tender p-30">
                            <div className="tender-title mb-2">
                              <p className="head ">
                                <u>{this.props.state.language === "ma" ? item?.title_ma : item?.tender_title}</u>
                              </p>
                            </div>
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Tender By</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                <p>{this.props.state.language === "ma" ? item?.organized_by_ma : item?.organized_by}</p>
                              </div>
                            </div>
                            {item?.value_of_tender &&
                              item?.value_of_tender != 0 && (
                                <div className="tender-datas">
                                  <div className="col-lg-2 col-md-12 col-sm-12 label">
                                    <p>Value of Tender</p>
                                  </div>
                                  <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                    <p>₹ {this.formatAmount(item?.value_of_tender)}</p>
                                  </div>
                                </div>
                              )}
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Description</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>
                                  {this.props.state.language === "ma"
                                    ? item?.description_ma && ReactHtmlParser(item?.description_ma)
                                    : item?.description && ReactHtmlParser(item?.description)}
                                </p>
                              </div>
                            </div>
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Due Date</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>{item?.due_date ? moment(item?.due_date, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm") : "--"}</p>
                              </div>
                            </div>
                            {item?.link && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Link</p>
                                </div>

                                <div className="d-flex   col-lg-10 col-md-12 col-sm-12 contentx overf">
                                  <p className="blink_me ">
                                    <CustomIcons iconName={"hand"} />
                                  </p>

                                  <span className="">
                                    &nbsp;
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        const url = /^https?:\/\//.test(item.link) ? item.link : `https://${item.link}`;
                                        window.open(url, "_blank");
                                      }}
                                      className="break_link"
                                    >
                                      {item?.link}
                                    </a>
                                  </span>
                                </div>
                              </div>
                            )}
                            {item?.file && item?.file !== "storage/" && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Document</p>
                                </div>
                                {item?.file && (
                                  <div className="d-flex align-items-center col-lg-10 col-md-12 col-sm-12 contentx overf">
                                    <p className="blink_me">
                                      <CustomIcons iconName={"hand"} />
                                    </p>

                                    <span className="">
                                      &nbsp;
                                      <a
                                        onClick={(e) =>
                                          this.handleDownloadProof(item?.file)}
                                        className="break_link"
                                      >
                                        {" "}
                                        Download
                                      </a>
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                    </React.Fragment>
                  ))}

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-4 px-4 w-100 flex-wrap pagination-container" style={{ gap: '15px' }}>
                      <div className="text-muted" style={{ fontSize: "14px" }}>
                        {this.props.state.language === "ma" ? (
                          <>കാണിക്കുന്നത് <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> (ആകെ <b>{totalItems}</b> ടെൻഡറുകൾ)</>
                        ) : (
                          <>Showing <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> of <b>{totalItems}</b> Tenders</>
                        )}
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          className="btn btn-outline-primary btn-sm px-3 py-2"
                          disabled={currentPage === 1}
                          onClick={() => this.setState({ currentPage: currentPage - 1 })}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          <i className="fa fa-chevron-left mr-1"></i> {this.props.state.language === "ma" ? "മുമ്പത്തെ" : "Prev"}
                        </button>

                        {(() => {
                          const pages = [];
                          const maxVisible = 5;
                          let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                          let end = Math.min(totalPages, start + maxVisible - 1);
                          if (end - start + 1 < maxVisible) {
                            start = Math.max(1, end - maxVisible + 1);
                          }

                          if (start > 1) {
                            pages.push(
                              <button
                                key={1}
                                className={`btn btn-sm px-3 py-2 ${currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: 1 })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                1
                              </button>
                            );
                            if (start > 2) {
                              pages.push(<span key="dots-start" className="px-2 align-self-center text-muted">...</span>);
                            }
                          }

                          for (let i = start; i <= end; i++) {
                            pages.push(
                              <button
                                key={i}
                                className={`btn btn-sm px-3 py-2 ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: i })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                {i}
                              </button>
                            );
                          }

                          if (end < totalPages) {
                            if (end < totalPages - 1) {
                              pages.push(<span key="dots-end" className="px-2 align-self-center text-muted">...</span>);
                            }
                            pages.push(
                              <button
                                key={totalPages}
                                className={`btn btn-sm px-3 py-2 ${currentPage === totalPages ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: totalPages })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                {totalPages}
                              </button>
                            );
                          }
                          return pages;
                        })()}

                        <button
                          className="btn btn-outline-primary btn-sm px-3 py-2"
                          disabled={currentPage === totalPages}
                          onClick={() => this.setState({ currentPage: currentPage + 1 })}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          {this.props.state.language === "ma" ? "അടുത്തത്" : "Next"} <i className="fa fa-chevron-right ml-1"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default tenders;
